// extracted by mini-css-extract-plugin
export default {"positive":"VarianceCell_positive__5e0rA","negative":"VarianceCell_negative__OhMrQ"};